import DynamicComponent from "./DynamicComponent"

export default DynamicComponent
